<template>
  <div class="tw-flex tw-items-center tw-gap-2">
    <SfButtonDs
      v-if="!itemsStore.isEmpty"
      id="workflow-review-compare-toggle"
      :disabled="reloadingMode"
      @click="toggleCompareMode"
    >
      <span class="tw-flex tw-items-center tw-gap-2">
        <!-- The button owns the click, so the checkbox must not add a second
             one: its label forwards a click that bubbles, and it is focusable. -->
        <SfToggle
          :disabled="reloadingMode"
          :model-value="uiStore.compareMode"
          :icons="false"
          tabindex="-1"
          @click.prevent.stop
        />
        <span>{{ I18n.t('workflow_review.period_comparison') }}</span>
      </span>
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useComparisonModeToggle } from '@app/application/workflows/composables/use-comparison-mode-toggle'
import { SfButtonDs } from '@silverfin/ui-components'
import SfToggle from '@app/shared/vue/components/sf-toggle.vue'

import { useWorfklowReviewItems } from '../store/pinia/workflow-review-items'
import { useWorfklowUI } from '../store/pinia/workflow-ui'

defineOptions({
  name: 'WorkflowReviewSubnavSecondaryRight',
})

interface Props {
  ledgerId: number
  workflowId: number
}

const props = defineProps<Props>()

const itemsStore = useWorfklowReviewItems()
const uiStore = useWorfklowUI()

const {
  compareLedgerId: storedComparedLegerId,
  compareMode,
  reloadingMode,
  reloadingLedger,
} = storeToRefs(uiStore)

const I18n = window.I18n

const { turnOnCompareMode, turnOffCompareMode } = useComparisonModeToggle(true)

async function toggleCompareMode() {
  if (reloadingMode.value || reloadingLedger.value) {
    return
  }

  const shouldTurnOn = !compareMode.value

  if (shouldTurnOn) {
    if (!storedComparedLegerId.value) {
      uiStore.updateCompareMode(true)
      return
    }

    turnOnCompareMode({
      ledgerId: props.ledgerId,
      workflowId: props.workflowId,
    })
  } else {
    turnOffCompareMode({
      ledgerId: props.ledgerId,
      workflowId: props.workflowId,
    })
  }
}
</script>
